module.exports = __webpack_public_path__ + "static/logo-6008307b56c773544742580187dd7e61.png";